/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StorageFeeRetryResultDto } from './StorageFeeRetryResultDto';
import {
    StorageFeeRetryResultDtoFromJSON,
    StorageFeeRetryResultDtoFromJSONTyped,
    StorageFeeRetryResultDtoToJSON,
    StorageFeeRetryResultDtoToJSONTyped,
} from './StorageFeeRetryResultDto';

/**
 * 
 * @export
 * @interface ResponseListStorageFeeRetryResultDto
 */
export interface ResponseListStorageFeeRetryResultDto {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStorageFeeRetryResultDto
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStorageFeeRetryResultDto
     */
    message?: string;
    /**
     * 
     * @type {Array<StorageFeeRetryResultDto>}
     * @memberof ResponseListStorageFeeRetryResultDto
     */
    data?: Array<StorageFeeRetryResultDto>;
}

/**
 * Check if a given object implements the ResponseListStorageFeeRetryResultDto interface.
 */
export function instanceOfResponseListStorageFeeRetryResultDto(value: object): value is ResponseListStorageFeeRetryResultDto {
    return true;
}

export function ResponseListStorageFeeRetryResultDtoFromJSON(json: any): ResponseListStorageFeeRetryResultDto {
    return ResponseListStorageFeeRetryResultDtoFromJSONTyped(json, false);
}

export function ResponseListStorageFeeRetryResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStorageFeeRetryResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StorageFeeRetryResultDtoFromJSON)),
    };
}

export function ResponseListStorageFeeRetryResultDtoToJSON(json: any): ResponseListStorageFeeRetryResultDto {
    return ResponseListStorageFeeRetryResultDtoToJSONTyped(json, false);
}

export function ResponseListStorageFeeRetryResultDtoToJSONTyped(value?: ResponseListStorageFeeRetryResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StorageFeeRetryResultDtoToJSON)),
    };
}

